import { useEffect, useState } from "react";
import { History, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { fmtDateTime } from "../../lib/format";

export const STATUS_LABEL = {
  uploaded: ["Caricato", "bg-slate-100 text-slate-600"], analyzed: ["Analizzato", "bg-blue-50 text-blue-700"],
  importing: ["In corso", "bg-amber-50 text-amber-700"], completed: ["Completato", "bg-emerald-50 text-emerald-700"],
  completed_with_errors: ["Completato con errori", "bg-amber-50 text-amber-800"], failed: ["Fallito", "bg-red-50 text-red-700"],
  rolled_back: ["Annullato (rollback)", "bg-slate-200 text-slate-700"],
};
export const ENTITY_LABEL = { aziende: "Aziende", contatti: "Contatti", lead: "Lead", opportunita: "Opportunità", aziende_contatti: "Aziende + Contatti" };

export function StatusPill({ status }) {
  const [l, c] = STATUS_LABEL[status] || [status, "bg-slate-100 text-slate-600"];
  return <span data-testid="batch-status" className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${c}`}>{l}</span>;
}

export default function ImportHistory({ onOpen }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/import/batches").then(({ data }) => setRows(data)); }, []);
  if (!rows.length) return <div className="bg-white rounded-xl border border-slate-200 py-14 text-center text-slate-400" data-testid="import-history-empty"><History className="w-8 h-8 mx-auto mb-2 opacity-40" />Nessuna importazione eseguita</div>;
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden table-scroll" data-testid="import-history">
      <table className="w-full text-sm">
        <thead><tr className="border-b border-slate-100 text-left text-xs uppercase tracking-wider text-slate-400">
          <th className="px-4 py-3 font-medium">Data</th><th className="px-4 py-3 font-medium">File / Origine</th><th className="px-4 py-3 font-medium">Entità</th><th className="px-4 py-3 font-medium">Source</th><th className="px-4 py-3 font-medium">Utente</th>
          <th className="px-4 py-3 font-medium text-right">Righe</th><th className="px-4 py-3 font-medium text-right">Importati</th><th className="px-4 py-3 font-medium text-right">Aggiornati</th><th className="px-4 py-3 font-medium text-right">Ignorati</th><th className="px-4 py-3 font-medium text-right">Errori</th><th className="px-4 py-3 font-medium">Stato</th><th />
        </tr></thead>
        <tbody>
          {rows.map((b) => (
            <tr key={b.id} data-testid={`batch-row-${b.id}`} className="border-b border-slate-50 hover:bg-slate-50 cursor-pointer" onClick={() => onOpen(b.id)}>
              <td className="px-4 py-3 font-mono text-xs text-slate-500">{fmtDateTime(b.created_at)}</td>
              <td className="px-4 py-3"><p className="font-medium text-slate-800">{b.filename}</p><p className="text-xs text-slate-400 font-mono">{b.format?.toUpperCase()} · {b.origin} · {b.id.slice(0, 8)}</p></td>
              <td className="px-4 py-3 text-slate-600">{ENTITY_LABEL[b.entity]}</td>
              <td className="px-4 py-3 text-slate-600">{b.source || "—"}</td>
              <td className="px-4 py-3 text-slate-600 text-xs">{b.user_name || b.user_email}</td>
              <td className="px-4 py-3 text-right font-mono">{b.row_count}</td>
              <td className="px-4 py-3 text-right font-mono text-emerald-700">{b.counts?.importati ?? "—"}</td>
              <td className="px-4 py-3 text-right font-mono text-blue-700">{b.counts ? (b.counts.aggiornati + b.counts.uniti) : "—"}</td>
              <td className="px-4 py-3 text-right font-mono text-slate-500">{b.counts ? (b.counts.ignorati + b.counts.collegati) : "—"}</td>
              <td className="px-4 py-3 text-right font-mono text-red-600">{b.counts?.errori ?? b.summary?.errore ?? "—"}</td>
              <td className="px-4 py-3"><StatusPill status={b.status} /></td>
              <td className="px-2"><ArrowRight className="w-4 h-4 text-slate-300" /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
